import React from 'react'
import { Jumbotron } from 'react-bootstrap';
import styles from './Showcase.module.css'

const Showcase = () =>{
    return (
        <div id="showcase">
             <Jumbotron className ={styles.flex} class="text-center">
              <div className="text-center"><h5  className={styles.media}>
                Do you want your Kid to master the English language as his
                mother-tongue?
              </h5> 
              <p className="lead text-white text-center">
                Then, No doubt.. Buy Mr.Mack, NOW!
              </p>
              <a href="#About" className="btn btn-outline-secondary btn-lg text-white">
                <i className="fas fa-arrow-right"></i> Read More
              </a>
              </div>
              <div className="col-lg-6">
              <img
                src="img/book.jpg "
                alt=""
                className="img-fluid d-none mt-5 ml-5 d-lg-block"
              />
            </div>
              </Jumbotron>
              <div className="bg-dark" style={{padding:"2rem"}}>
</div>
          </div>
    )
}

export default Showcase
